package org.matthewo.api

import kotlinx.serialization.Serializable

@Serializable
data class AdvancementPoints(
    val qual: Int,
    val alliance: Int,
    val playoff: Int,
    val award: Int,
) {
    val total get() = qual + alliance + playoff + award
}

@Serializable
data class TeamAdvancementPoints(
    val number: Int,
    val name: String,
    val alreadyAdvanced: Boolean,
    val advancement: AdvancementPoints,
)

@Serializable
data class EventAdvancement(
    val slots: Int,
    val worldsSlots: Int,
    val teams: List<TeamAdvancementPoints>,
)

val ADVANCEMENT_SORT =
    compareBy<TeamAdvancementPoints> { it.advancement.total }
        .thenBy { it.advancement.award }
        .thenBy { it.advancement.playoff }
        .thenBy { it.advancement.alliance }
        .thenBy { it.advancement.qual }
